import React, { useState, useEffect } from 'react';
import { api } from '../api';
import './Modal.css';

export default function CredentialsModal({ domain, onClose }) {
  const [creds, setCreds] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.getCredentials(domain)
      .then(d => setCreds(d.credentials))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [domain]);

  function handleCopy() {
    navigator.clipboard.writeText(creds);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>🔑 Credentials — {domain}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="center"><div className="spinner" /></div>
          ) : error ? (
            <div className="modal-error">{error}</div>
          ) : (
            <>
              <pre className="deploy-log" style={{ color: 'var(--accent2)' }}>{creds}</pre>
              <div className="modal-footer-note">
                📁 Saved at: <code>/home/leon/docker/clients/{domain}/credentials.txt</code>
              </div>
              <div className="modal-footer">
                <button className="btn-ghost" onClick={handleCopy}>
                  {copied ? '✓ Copied!' : 'Copy'}
                </button>
                <button className="btn-primary" onClick={onClose}>Close</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
